import React from 'react';
import {useSelector} from 'react-redux';

import {hooks} from '../hooks';
import {DishType} from '../types';
import {SonsType} from '../types';
import {svg} from '../assets/svg';
import {RootState} from '../store';
import {actions} from '../store/actions';
import {components} from '../components';
import { Routes } from '../routes';
  
type Props = {
  index: number;
  son: SonsType;
  isLast: boolean;
};

export const MySonsItem: React.FC<Props> = ({index, son, isLast}) => {
  const navigate = hooks.useNavigate();
  const dispatch = hooks.useDispatch();

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'flex-start',
        gap: 16,
        width: '100%',
      }}
    >
      <div style={{flex: 1, flexFlow: 'row'}}>
        <img
          src={son.banner}
          alt={son.name}
          style={{
            maxWidth: '100%', 
            width: '175px',
            maxHeight: '100%',
            height: '135px',
            objectFit: 'cover',
            objectPosition: 'top center',
            borderRadius: 6
          }}
          onClick={() => navigate(`/detail-sons/${son.id}`, {state: {son}})}
        />
        <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-evenly', marginTop: 10, borderTop: '1px solid var(--border-color)', paddingTop: 8, gap: 15}}>
          <span onClick={() => navigate(`/detail-sons/detail-sons-grade-analysis/${son.id}`, {state: {son}})} style={{width:'100%', display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: 6, border: '1px solid var(--border-color)', backgroundColor: 'var(--main-turquoise)'}}>
            <img style={{width: 36, padding: '7px 10px 7px 0'}} className='clickable' src="/assets/img-icon/chart-white.png" alt="chart Icon" />
            <p className='t10' style={{textAlign: 'center', color: 'white'}}>Grade Analysis</p>
          </span>
        </div>
      </div>
      {/* <components.Name
        son={son.name}
        containerStyle={{marginBottom: 3}}
      /> */}
      <div style={{flex: 1, minWidth: 140}}>
        <p
          className='t10'
          style={{lineHeight: 1.2, textAlign: 'left'}}
        >
          Ananda
        </p>
        <h4 style={{marginBottom: 10, paddingTop: 5}}>{son.name}</h4>
        <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-evenly', marginTop: 10, borderTop: '1px solid var(--border-color)', paddingTop: 10, gap: 15}}>
          <span onClick={() => navigate(`/detail-sons/detail-sons-absensi/${son.id}`, {state: {son}})}>
            <img style={{maxWidth: 50, padding: 10, borderRadius: 6, border: '1px solid var(--border-color)', backgroundColor: 'var(--main-turquoise)'}} className='clickable' src="/assets/img-icon/absensi-icon-white.png" alt="Absensi Icon" />
            <p className='t10' style={{textAlign: 'center'}}>Absensi</p>
          </span>
          <span onClick={() => navigate(`/detail-sons/detail-sons-rkh/${son.id}`, {state: {son}})}>
            <img style={{maxWidth: 50, padding: 10, borderRadius: 6, border: '1px solid var(--border-color)', backgroundColor: 'var(--main-turquoise)'}} className='clickable' src="/assets/img-icon/rkh-icon-white.png" alt="RKH Icon" />
            <p className='t10' style={{textAlign: 'center'}}>RKH</p>
          </span>
        </div>
        <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-evenly', marginTop: 10, gap: 15}}>
          <span onClick={() => navigate(`/detail-sons/detail-sons-raport/${son.id}`, {state: {son}})}>
            <img style={{maxWidth: 50, padding: 10, borderRadius: 6, border: '1px solid var(--border-color)', backgroundColor: 'var(--main-turquoise)'}} className='clickable' src="/assets/img-icon/raport-icon-white.png" alt="Raport Icon" />
            <p className='t10' style={{textAlign: 'center'}}>Raport</p>
          </span>
          <span onClick={() => navigate(`/detail-sons/detail-sons-subjects/${son.id}`, {state: {son}})}>
            <img style={{maxWidth: 50, padding: 10, borderRadius: 6, border: '1px solid var(--border-color)', backgroundColor: 'var(--main-turquoise)'}} className='clickable' src="/assets/img-icon/study-icon-white.png" alt="Study Icon" />
            <p className='t10' style={{textAlign: 'center'}}>Subjects</p>
          </span>
        </div>
      </div>
    </div>
  );
};
